var styles = {"box":"RDWrapper_box_15bsf_1","tab-panel":"RDWrapper_tab-panel_15bsf_5","content-wrapper":"RDWrapper_content-wrapper_15bsf_17","trigger":"RDWrapper_trigger_15bsf_91"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
